





import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "CurrencyTitle",
  props: {
    currency: { type: String, required: true },
  },
});
